<style>
    body {
        background: #f8f8f8;
        margin: 0;
        padding: 0;
    }

    p {
        margin: 0;
    }

    ul {
        margin: 0;
        padding: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .header {
        padding: 40px;
    }

    .content {
        background: #fff;
    }
    ul {
        margin-bottom: 14px;
        list-style: none;
    }

    ul {
        margin-bottom: 14px;
        list-style: none;
    }
    .file_li {
        display: block;
        margin: 10px 0 7px 0;
        background-repeat: no-repeat;
        background-position: 97% center;
        font-size: 14px;
        color: white;
        padding: 5px 0 0 20px;
        text-decoration: none;
    }


    .orange { background-color: #F5876E; }

    .blue{ background-color: #62A9DC; }

    .green{ background-color: #8EBD40; }

    .purple { background-color: #988CC3; }

    .gold { background-color: #D8C86E; }

    .file_span {
        width: 300px; height: 30px;  margin: 0 0 7px 0;
    }

</style>

<template>
    <div id="component">
        <CRow>
            <CCol sm="8">
                <CCard>
                    <CCardHeader>
                        대상자 현재상태 사진 등록
                    </CCardHeader>
                    <CCardBody>
                        <CForm>
                            <CInput prepend="대상자이름" v-model="name" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>
                            <CInput prepend="진료번호" v-model="registNo" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>
                          <!--  <CInput prepend="환자번호" v-model="custId" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>-->
                            <CInput type="date" v-model="picDate"  prepend="날짜"  min="2000-01-02" max="2999-12-31" >
                            </CInput>
                            <div class="card-body p-3 d-flex align-items-center">
                                <div class="bg-gradient-warning mfe-3">
                                </div>
                            </div>

                            <div class="example-drag">
                                <div class="upload">
                                    <ul v-if="files.length" style="margin-bottom: 20px;" >
                                        <li v-for="(file, index) in files" :key="file.id" style="height: 30px;" class="purple file_li" >
                                            <a style="color: #fff; font-size: 14px;background-color: #988CC3;padding-top:6px;padding-bottom:6px;"> 파일명 : {{file.name}} ({{file.size | formatSize}} Byte)
                                            </a>
                                            <span style="height: 30px;" v-if="file.error"><span class="badge badge-secondary float-right" style="padding: 3px; margin-right: 5px;">업로드 실패</span></span>
                                            <span style="height: 30px;" v-else-if="file.success"><span class="badge badge-success float-right" style="padding: 3px; margin-right: 5px;">업로드 성공</span></span>
                                            <span style="height: 30px;" v-else-if="file.active">active</span>
                                            <span style="height: 30px;" v-else></span>
                                        </li>
                                    </ul>
                                    <ul v-else style="background: #eee;margin-bottom: 20px;">
                                        <td colspan="7">
                                            <div class="text-center p-5">
                                                파일을 등록해주세요.
                                            </div>
                                        </td>
                                    </ul>

                                    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                                        <h3>Drop files to upload</h3>
                                    </div>

                                    <div class="example-btn">
                                        <file-upload
                                                class="btn btn-primary"
                                                style="width: 0px;height: 0px; display: none;"
                                                post-action="silver/fileUpload"
                                                :multiple="true"
                                                :drop="true"
                                                :drop-directory="true"
                                                v-model="files"
                                                :data="{
                                                  custId: this.custId,
                                                  picDate:$moment(this.picDate).format('YYYYMMDD'),
                                                }"
                                                name="upload"
                                                @input-file="inputFile"
                                                @input-filter="inputFilter"
                                                ref="upload">

                                        </file-upload>
                                    </div>
                                </div>
                            </div>
                     <!--       <uploader
                                    v-model="fileList"
                                    title="이미지 업로드"
                                    name="upload"
                                    limit="5"
                                    :params="{
                                      custId: this.custId,
                                      picDate:this.$moment().format('YYYYMMDD'),
                                    }"
                                    :headers="{
                                      'custom-header': 'custom-info',
                                    }"
                                    @on-change="onChange"
                                    @on-cancel="onCancel"
                                    @on-success="onSuccess"
                                    @on-error="onError"
                            />-->
                            <div class="form-group form-actions">
                                <div class="col-sm-0.5">
                                    <CButton label=""
                                             type="button"
                                             style="text-align: right"
                                             class="btn btn-info " @click="backHistory">뒤로가기
                                    </CButton>
                                <!--  <CButton label=""
                                             type="button"
                                             style="text-align: center; float: right; margin-right:10px;"
                                             class="btn btn-info " @click="wellnesssInsert">등록
                                    </CButton>-->
                                    <button type="button"   style="text-align: center; float: right; margin-right:10px;" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                        <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                        업로드
                                    </button>
                                    <button type="button"   style="text-align: center; float: right; margin-right:10px;" class="btn btn-danger"  v-else @click.prevent="$refs.upload.active = false">
                                        <i class="fa fa-stop" aria-hidden="true"></i>
                                        업로드 중지
                                    </button>
                                    <label for="upload" style="text-align: center; float: right; margin-right:10px;" class="btn btn-success" >파일선택</label>
                                </div>
                            </div>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Uploader from "vux-uploader-component";
    import FileUpload from 'vue-upload-component'
    import VueMoment from 'vue-moment'
    import Vue from 'vue'
    import axios from "axios";

    Vue.use(VueMoment)

    export default {
        name: 'app',
        components: {
            Uploader
            ,FileUpload
        },
        data() {
            return {
                custId: this.$route.params.custId,
                picDate: this.$moment().format('YYYY-MM-DD'),
                url: '',
                adminId: '',
                albumId:'',
                fileList: [],
                files: [],
                name:"",
                registNo:""
            }
        },
        mounted() {
            axios.get("silver/cust/wellness/getCustInfo?custId="+this.custId)
            .then(res => {
                this.name = res.data.cust.name;
                this.registNo = res.data.cust.registNo;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            onChange(fileItem, fileList) {
                console.log('on-change: ', fileItem, fileList)
            },
            onCancel() {
                console.log('on-cancel: Sucess')
            },
            onSuccess(res, fileItem) {
                console.log('on-success: ', res)
                fileItem.fileid = res.data
                this.albumId = res.albumId
                console.log(this.attachId);
                alert("등록되었습니다.");
            },
            onError(res) {
                console.log('on-error: ', res)
            },
            onDelete(cb) {
                this.albumId = '';
                console.log('on-delete: ', JSON.parse(JSON.stringify(this.fileList)))
                cb && cb()
            },
            onload(e, r) {
                console.log(r)
            },
            backHistory() {
                this.$router.go(-1)
            },
            /**
             * Has changed
             * @param  Object|undefined   newFile   Read only
             * @param  Object|undefined   oldFile   Read only
             * @return undefined
             */
            inputFile: function (newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    // Get response data
                    console.log('response', newFile.response)
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status)
                    }
                }
            },
            /**
             * Pretreatment
             * @param  Object|undefined   newFile   Read and write
             * @param  Object|undefined   oldFile   Read only
             * @param  Function           prevent   Prevent changing
             * @return undefined
             */
            inputFilter: function (newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Filter non-image file
                    if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }

                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
            }
        }
    }
</script>
<style>
    .example-full .btn-group .dropdown-menu {
        display: block;
        visibility: hidden;
        transition: all .2s
    }
    .example-full .btn-group:hover > .dropdown-menu {
        visibility: visible;
    }
    .example-full label.dropdown-item {
        margin-bottom: 0;
    }
    .example-full .btn-group .dropdown-toggle {
        margin-right: .6rem
    }
    .example-full .filename {
        margin-bottom: .3rem
    }
    .example-full .btn-is-option {
        margin-top: 0.25rem;
    }
    .example-full .example-foorer {
        padding: .5rem 0;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
    }
    .example-full .edit-image img {
        max-width: 100%;
    }
    .example-full .edit-image-tool {
        margin-top: .6rem;
    }
    .example-full .edit-image-tool .btn-group{
        margin-right: .6rem;
    }
    .example-full .footer-status {
        padding-top: .4rem;
    }
    .example-full .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }
    .example-full .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
</style>



